export default __webpack_public_path__ + "static/media/dune.00499cf8.pdf";